import { useState } from "react";
import { useNavigate } from "react-router-dom";
import InteractiveCarte from "../../pages/Carte/InteractiveCarte";
import Water from "./Water";
import WaterLifecycle from "./WaterLifecycle";
import WaterPrice from "./WaterPrice";
import WaterResult from "./WaterResult";

const WaterNavigationMenu = () => {
  const [activeSection, setActiveSection] = useState("carte");

  const navigate = useNavigate();
  const handleSectionChange = (section: any) => {
    setActiveSection(section);
    navigate(`/eau?${section}`);
  };

  return (
    <>
      <div className="flex flex-col items-center p-10 mt-5 md:p-0">
        <div className="flex justify-center space-x-4">
          <div
            className={`cursor-pointer  text-xs md:text-base ${
              activeSection === "carte"
                ? "text-black  text-xs font-bold md:text-base "
                : ""
            }`}
            onClick={() => handleSectionChange("carte")}
          >
            Notre territoire
            <hr
              className={
                activeSection === "carte" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>

          <div
            className={`cursor-pointer  text-xs md:text-base ${
              activeSection === "cycle"
                ? "text-black  text-xs font-bold md:text-base "
                : ""
            }`}
            onClick={() => handleSectionChange("cycle")}
          >
            Cycle de l'eau
            <hr
              className={
                activeSection === "cycle" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>

          <div
            className={`cursor-pointer text-xs md:text-base${
              activeSection === "resultat"
                ? "text-black text-xs font-bold md:text-base "
                : ""
            }`}
            onClick={() => handleSectionChange("resultat")}
          >
            Resultat qualité de l'eau
            <hr
              className={
                activeSection === "resultat"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer text-xs md:text-base${
              activeSection === "prix"
                ? "text-black font-bold text-xs  md:text-base"
                : ""
            }`}
            onClick={() => handleSectionChange("prix")}
          >
            Prix de l'eau
            <hr
              className={
                activeSection === "prix" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer text-xs md:text-base${
              activeSection === "adoucissement"
                ? "text-black text-xs font-bold  md:text-base"
                : ""
            }`}
            onClick={() => handleSectionChange("adoucissement")}
          >
            Adoucissement de l'eau
            <hr
              className={
                activeSection === "adoucissement"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
        </div>
        <div className="z-0 w-full max-w-2xl border-t border-gray-200 dark:border-gray-800" />
      </div>

      {activeSection === "carte" && <InteractiveCarte />}
      {activeSection === "cycle" && <WaterLifecycle />}

      {activeSection === "resultat" && <WaterResult />}
      {activeSection === "prix" && <WaterPrice />}
      {activeSection === "adoucissement" && <Water />}
    </>
  );
};

export default WaterNavigationMenu;
